import CustomComponent from '../CustomComponent';

export class SectionBlockComponent extends CustomComponent {
	static key = 'lta-section-block';

	static get observedAttributes() {
		return ['header', 'description', 'classes', 'title-class', 'header-classes', 'description-classes'];
	}

	render(childrenHTML) {
		const {
			header = '',
			description = '',
			classes = '',
			titleClass = '',
			headerClasses = '',
			descriptionClasses = ''
		} = this.props;
		const slotContent = this._childrenHTML || childrenHTML || '';

		const classNames = ['lta-section-block', classes].filter(Boolean).join(' ');

		return `
			<div class="${classNames}">
				<lta-section-header
					title="${header}"
					classes="lta-section-block__header ${headerClasses}"
					title-class="${titleClass}"
				></lta-section-header>
				${description ? `<p class="lta-section-block__description ${descriptionClasses}">${description}</p>` : ''}
				${slotContent ? `<div class="lta-section-block__content">${slotContent}</div>` : ''}
			</div>
		`;
	}
}

export default SectionBlockComponent;
